import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-profile-image',
  template: `<div
  [ngClass]="small ? 'smallwrapper' : 'wrapper'"
  [appGradient]="first_name + last_name">
  {{ first_name.slice(0, 1) }}{{ last_name.slice(0, 1) }}
</div>
`,
  styles: [`.wrapper{width:50px;height:50px;line-height:50px;color:#fff;font-size:1.2rem;text-align:center;display:inline-block;border-radius:100%;text-transform:uppercase}.smallwrapper{width:25px;height:25px;line-height:25px;color:#fff;font-size:.6rem;text-align:center;display:inline-block;border-radius:100%;text-transform:uppercase}`]
})
export class ProfileImageComponent implements OnInit {
  @Input() first_name: string;
  @Input() last_name: string;
  @Input() small = false;
  constructor() { }

  ngOnInit() {
  }

}
